import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, Transition as _Transition, resolveDynamicComponent as _resolveDynamicComponent } from "vue"

const _hoisted_1 = { class: "mx-auto max-w-7xl sm:p-6 lg:p-8" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Select a report")
const _hoisted_3 = { class: "relative mt-2" }
const _hoisted_4 = { class: "block truncate" }
const _hoisted_5 = { class: "mt-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ListboxLabel = _resolveComponent("ListboxLabel")!
  const _component_ListboxButton = _resolveComponent("ListboxButton")!
  const _component_ListboxOption = _resolveComponent("ListboxOption")!
  const _component_ListboxOptions = _resolveComponent("ListboxOptions")!
  const _component_Listbox = _resolveComponent("Listbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Listbox, {
      as: "div",
      modelValue: _ctx.selectedReport,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedReport) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ListboxLabel, { class: "block text-sm font-medium leading-6 text-gray-900" }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_ListboxButton, { class: "relative w-full cursor-default rounded-md bg-white py-1.5 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-600 sm:text-sm sm:leading-6" }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.selectedReport.name), 1)
            ]),
            _: 1
          }),
          _createVNode(_Transition, {
            "leave-active-class": "transition ease-in duration-100",
            "leave-from-class": "opacity-100",
            "leave-to-class": "opacity-0"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ListboxOptions, { class: "absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm" }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reports, (person) => {
                    return (_openBlock(), _createBlock(_component_ListboxOption, {
                      as: "template",
                      key: person.id,
                      value: person
                    }, {
                      default: _withCtx(({ active, selected }) => [
                        _createElementVNode("li", {
                          class: _normalizeClass([active ? 'bg-indigo-600 text-white' : 'text-gray-900', 'relative cursor-default select-none py-2 pl-3 pr-9'])
                        }, [
                          _createElementVNode("span", {
                            class: _normalizeClass([selected ? 'font-semibold' : 'font-normal', 'block truncate'])
                          }, _toDisplayString(person.name), 3)
                        ], 2)
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.userComponent)))
    ])
  ]))
}